import type {PackagesItemByPerson, SelectedPackageCreditItem} from 'types/entities/PackagesItems'
import {PackageItemPersonType} from 'types/enums/PackageItemPersonType'
import {isSingleUnitCreditPackage} from 'utils/offers/addItemToCalculationUtils'

export const adultFirstPackageItems = (items: PackagesItemByPerson[]): PackagesItemByPerson[] =>
    items.filter((item) => item.id && item.quantity > 0).sort((a, b) =>
        Number(b.person_type === PackageItemPersonType.Adult) - Number(a.person_type === PackageItemPersonType.Adult)
    )

/** Map preserves adult-first order even when child package IDs are numerically lower. */
export const getEventPackageItemPayload = (items: PackagesItemByPerson[]): Record<number, number>[] => {
    const quantities = new Map<number, number>()
    for (const item of adultFirstPackageItems(items)) {
        quantities.set(item.id!, (quantities.get(item.id!) ?? 0) + item.quantity)
    }
    return [...quantities].map(([id, quantity]) => ({[id]: quantity}))
}

export const hasValidFamilyCreditOwner = (credits: SelectedPackageCreditItem[], items: PackagesItemByPerson[]): boolean =>
    !credits.some((item) => item.quantity > 0 && isSingleUnitCreditPackage(item.packageItem)) ||
    adultFirstPackageItems(items)[0]?.person_type === PackageItemPersonType.Adult
